var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmailFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 5.07617L22.9048 6.77855L19.8096 9.71903V19.8095H24.1429C25.1687 19.8095 26 18.9781 26 17.9524V5.07617Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.07617L2.23724 6.13474L6.19048 9.71903V19.8095H1.85714C0.831381 19.8095 0 18.9781 0 17.9524V5.07617Z",
    fill: "#1E88E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8094 1.98096L12.9999 7.0881L6.19034 1.98096L5.57129 5.57143L6.19034 9.71905L12.9999 14.8262L19.8094 9.71905L20.4284 5.57143L19.8094 1.98096Z",
    fill: "#E53935"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.66067V5.07619L6.19048 9.71905V1.98095L4.25657 0.531762C3.796 0.186333 3.23638 0 2.66067 0C1.19105 0 0 1.19105 0 2.66067Z",
    fill: "#C62828"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2.66067V5.07619L19.8096 9.71905V1.98095L21.7435 0.531762C22.204 0.186333 22.7637 0 23.3394 0C24.809 0 26 1.19105 26 2.66067Z",
    fill: "#FBC02D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailFooter);
export default __webpack_public_path__ + "static/media/gmailFooter.545b083727d54e77c7098b8f94cc9b0a.svg";
export { ForwardRef as ReactComponent };